import styled, { css } from "styled-components/native";

export const FeatureText = styled.View<any>`
	position: absolute;
	display: flex;
	border-radius: 16px;
	justify-content: center;
	flex-direction: column;

	${(props) =>
		!props.isNarrow &&
		css`
			gap: 1.5rem;
			top: 0px;
			left: 153px;
			padding: 5vh 5vw;
			max-width: 45%;
			height: 100%;
			z-index: 100;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			top: 1px;
			left: 1px;
			width: 108rem;
			height: 27rem;
			padding: 2.5rem;
			align-items: flex-start;
			gap: 1.5rem;
			flex-shrink: 0;
			border-color: transparent;
			z-index: 9;
		`}
`;

export const FeatureLineOne = styled.Text<any>`
	font-size: ${(props) => props?.fontSize};
	font-weight: 500;
	font-style: normal;
	line-height: ${(props) => props?.lineHeight};
	color: ${(props) => props?.hexCode};
	text-overflow: ellipsis;
`;

export const FeatureLineTwo = styled.Text<any>`
	font-size: ${(props) => props?.fontSize};
	font-weight: 500;
	font-style: normal;
	line-height: ${(props) => props?.lineHeight};
	color: ${(props) => props?.hexCode};
`;

export const TextContainer = styled.View<any>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1.5rem;
	align-self: stretch;
`;

export const StyledImageBanner = styled.View<any>`
	background-image: linear-gradient(90deg, #131313 0%, rgba(19, 19, 19, 0) 50%, rgba(19, 19, 19, 0) 100%), url(${(props) => props.imageBanner});
	background-size: cover;
	background-postion: center;
`;
